module.exports = __webpack_public_path__ + "static/santosfc-54123726edc97cba3f0d015272ed99e1.png";